import React from 'react';
import { Reveal } from './Reveal';
const QUOTE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/378277d6-f5ff-4097-8a96-94e1bc0dc9e4.jpg';
export function EditorialQuote() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-13" data-mp="utq1oogalql4">
      <img src={QUOTE_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-70" data-id="element-14" data-mp="ur51s4zk1kq0" />
      <div className="absolute inset-0 bg-warmwhite/55" aria-hidden="true" data-id="element-15" data-mp="1ni550dq2akgm"><div className="relative mx-auto flex min-h-[78vh] max-w-4xl items-center px-6 py-28 sm:px-10 sm:py-40" data-id="element-16" data-mp="1nfsom4zyci5o">
        <Reveal data-id="element-17" data-mp="1sem3a0qz6f7f">
          <blockquote className="font-serif text-[2.1rem] font-light leading-[1.22] tracking-[-0.015em] text-ink-900 sm:text-[3.4rem] lg:text-[4rem]" data-id="element-18" data-mp="1ehh0qaqgzygx">
            <span className="block" data-id="element-19" data-mp="1ih7oe5kp9yh8">Tu piel no necesita más productos.</span>
            <span className="mt-3 block italic text-sage-600" data-id="element-20" data-mp="30z347b4zpsp">
              Necesita la rutina correcta.
            </span>
          </blockquote>
        </Reveal>
      </div></div>
      
    </section>;
}